import { ethers } from 'ethers';
import { encodeFunctionData } from 'viem';

import useWrappedRPC from './useWrappedRPC';
import environments from '../utils/environments';
import { abiERC20 } from '../config/abi.contract';
import useToken from './useToken';
const { USDC_ADDRESS } = environments;

// USDC uses 6 decimals, not 18
const USDC_DECIMALS = 6;

function useWithdraw() {
  const { sendTransactionWithGas } = useWrappedRPC();
  const { getUSDCBalance } = useToken();

  const handleWithdraw = async (receivedWalletAddress, usdcAmount) => {
    try {
      if (!usdcAmount || isNaN(usdcAmount) || Number(usdcAmount) <= 0) {
        throw new Error('Invalid amount. Please enter a positive number for USDC amount.');
      }

      if (!ethers.utils.isAddress(receivedWalletAddress)) {
        throw new Error('Invalid wallet address');
      }

      if (!USDC_ADDRESS || !ethers.utils.isAddress(USDC_ADDRESS)) {
        throw new Error('Invalid or missing USDC contract address');
      }

      const balance = await getUSDCBalance();
      if (balance < usdcAmount) {
        throw new Error(`Insufficient USDC balance. Available: ${balance} USDC`);
      }

      // Encode the ERC-20 transfer call
      const usdcValue = ethers.utils.parseUnits(usdcAmount.toString(), USDC_DECIMALS);
      const data = encodeFunctionData({
        abi: abiERC20,
        functionName: 'transfer',
        args: [receivedWalletAddress, usdcValue],
      });

      const transactionRequest = {
        to: USDC_ADDRESS,
        data,
      };
      const txUiConfig = {
        header: `Withdraw`,
        description: `Withdraw ${usdcAmount} USDC to address: ${receivedWalletAddress}`,
        buttonText: `Withdraw`,
      };

      const { txReceipt } = await sendTransactionWithGas(transactionRequest, txUiConfig);
      if (!txReceipt) throw new Error('Transaction failed on blockchain');

      return {
        success: true,
        message: `Sent ${usdcAmount} USDC to ${receivedWalletAddress}`,
        data: txReceipt.hash,
      };
    } catch (error) {
      console.error('Withdraw transaction failed:', error);
      return { success: false, message: error.message };
    }
  };

  return { handleWithdraw };
}

export default useWithdraw;
